import esContent from './cloudflare.es';

export default {
  ...esContent,
};
